'use strict';

import promiseIdle from './promise-idle';
import ready from './ready';

ready().then(promiseIdle()).then(function init() {
    const classes = document.documentElement.classList;
    const skips = document.querySelector('.skips');
    let timeoutId;

    if (skips) {
        skips.addEventListener('focusin', function () {
            clearTimeout(timeoutId);
            classes.add('skips-on');
        });
        skips.addEventListener('focusout', function () {
            // to let time for click event to trigger
            timeoutId = setTimeout(function () {
                classes.remove('skips-on');
            }, 10);
        });
    }
});